import { Component, Injector, Input, OnDestroy, OnInit, ElementRef } from '@angular/core';
import { BaseFormComponent } from '../base-form.component';
import { SubjectManager } from '../../../../../../common/js/subjectManager/SubjectManager';
import { Subscription } from 'rxjs';
import { Utils } from '../../../../../../common/js/Utils';

@Component({
  moduleId: module.id,
  selector: 'basic-label',
  templateUrl: './basic-label.component.html',
})
export class BasicLabelComponent extends BaseFormComponent implements OnInit, OnDestroy {
  @Input() levelClasses: string;
  @Input() inputClass: string;
  @Input() componentId: string;
  @Input() includeToolTip = true;

  /** display as is. do not go through parser */
  @Input() overrideDisplayText: string;
  additionalDescription: string;
  displayText: string;
  elementRef: ElementRef;
  scrollId: string;
  updateWaiverSubscription: Subscription;
  isTooltipDisabled: boolean;
  showQuestionLock: boolean = false;
  questionLockToolTip: string;

  constructor(protected injector: Injector, element_ref: ElementRef) {
    super(injector);
    this.elementRef = element_ref;
    this.isTooltipDisabled = this.getIsTooltipDisabled();
  }

  ngOnInit() {
    super.ngOnInit();
    this.getShowQuestionLock();
    this.questionAnsweredHandler();

    const updateWaiverSubject = SubjectManager.getSubject('update_waiver');
    this.updateWaiverSubscription = updateWaiverSubject.subscribe(() => {
      this.refreshDisplayText();
    });
    SubjectManager.setSubject('update_waiver', updateWaiverSubject);

    // Figure out if we need this done here or as an input parameter from radio group, basic text, select, and checkbox
    this.levelClasses = this.levelClasses || this.getLevelClass();
    if (this.questionItem.id) {
      this.scrollId = 'label-scroll-point__' + this.questionItem.id;
    }
  }

  ngOnDestroy() {
    if (this.questionAnsweredSubscription) {
      this.questionAnsweredSubscription.unsubscribe();
    }
    if (this.updateWaiverSubscription) {
      this.updateWaiverSubscription.unsubscribe();
    }
  }

  /**
   * updates the text that is displayed on the basic label component
   * if there is an override from custom components such as Driver's License,
   * we will set displayText to the override, otherwise we use the qText from
   * metadata and run it through the usual parsers
   */
  questionAnsweredHandler(): void {
    this.refreshDisplayText();
    this.additionalDescription = this.parsePredicates(this.questionItem.questionDescription);
  }

  refreshDisplayText(): void {
    if (this.overrideDisplayText) {
      this.displayText = this.overrideDisplayText;
    } else {
      this.displayText = this.parsePredicates(this.questionItem.qText);
      this.displayText = this.parseTripleUnderscores();
    }
    if (this.showQuestionLock && this.isAdvisor) {
      this.displayText = `<span class="question-lock--required"> *  </span>  ` + this.displayText;
    }
  }

  getShowQuestionLock() {
    if (
      this.appSvc.appState.controller.isQuestionLockEnabled &&
      this.questionItem.isQuestionLockable &&
      this.isAdvisor &&
      this.appSvc.appState.controller.customer.application.lockedByAdvisor
    ) {
      //on Agent side
      this.showQuestionLock = true;
      this.questionLockToolTip = `Your client can't edit this question`;
    } else if (
      !this.isAdvisor &&
      this.appSvc.appState.controller.isQuestionLockEnabled &&
      this.appSvc.appState.controller.customer.application.lockedByAdvisor &&
      this.questionItem.isQuestionLockable
    ) {
      //on client side
      this.showQuestionLock = true;
      this.questionLockToolTip = `Contact your financial professional if you want to make changes.`;
    }
  }

  parseTripleUnderscores(): string {
    if (this.displayText) {
      return this.displayText.replace('___', ' <span class="label-basic__bottom-line"> </span> ');
    } else {
      return '';
    }
  }

  updateFromModel() {}

  getIsTooltipDisabled(): boolean {
    return this.questionItem && Utils.exists(this.questionItem.tooltipDisabledOverride)
      ? this.questionItem.tooltipDisabledOverride
      : this.isDisabled;
  }
}
